import { useRouter } from 'next/router';
import React, { useState, useEffect, useContext } from 'react';
import { useSelector } from 'react-redux';
import ConnectedBottomDeals, {
  LAYOUT_TYPES,
} from '../../../components/deal/ConnectedBottomDeals';
import {
  fetchDeals,
  giftFinderGetKeyGenerator,
} from '../../../components/deal/ConnectedBottomDeals/helpers';
import { GiftFinderFiltersEmpty } from '../../../components/filters/GiftFinder/GiftFinderFiltersEmpty';
import { GiftFinderFiltersIcons } from '../../../components/filters/GiftFinder/GiftFinderFiltersIcons';
import { SEARCH_PAGE_SIZE } from '../../../config/links/links';
import { trackPage } from '../../../helpers/analytics';
import { useGiftFinderMeta } from '../../../helpers/api';
import { parseWowcherPath } from '../../../helpers/url';
import HeaderFooterLayout from '../../../layouts/HeaderFooterLayout';
import ThemeContext from '../../../providers/ThemeProvider';
import { setOnlySSR } from '../../../redux/actions/deals';
import { getServerSideEssentials } from '../../../redux/actions/ssr';
import { wrapper } from '../../../redux/store/store';

const GiftFinder = () => {
  const router = useRouter();
  const theme = useContext(ThemeContext);
  const ONE_TAG_RETURNED_RESULTS = 2;
  const location = useSelector((state) => state.locations.location);
  const [filterReset, setFilterReset] = useState(false);

  const { categoryOptions, count, searchResult, ready } = useGiftFinderMeta({
    location,
  });
  const { searchParams } = parseWowcherPath(router.asPath);
  const searchTagsFromQuery = searchParams.getAll('searchTag');

  // We show the no-deal message when
  // - we don't have any deals or
  // - we don't have deals for the sub category and BE returns the deals from the main category
  // with param searchResult = 2

  const isShowMessage =
    ready &&
    count > -1 &&
    searchResult === ONE_TAG_RETURNED_RESULTS &&
    searchTagsFromQuery.length > 0;

  useEffect(() => {
    if (categoryOptions) {
      trackPage({
        location,
        pageName: 'Gift finder',
      });
    }
  }, []);

  return (
    <>
      <div className="gift-finder" data-testid="gift-finder">
        <GiftFinderFiltersIcons
          filterReset={filterReset}
          searchParameters={searchParams}
          setFilterReset={setFilterReset}
        />

        {isShowMessage && (
          <GiftFinderFiltersEmpty setFilterReset={setFilterReset} />
        )}

        <div className="container">
          <ConnectedBottomDeals
            fetcherFunction={fetchDeals}
            getKeyGenerator={giftFinderGetKeyGenerator({
              location: location.shortName,
            })}
            pageSize={SEARCH_PAGE_SIZE}
            templateType={LAYOUT_TYPES.twoByTwo}
          />
        </div>
        <style jsx>{`
          .gift-finder {
            position: relative;
          }
          .gift-finder :global(.empty-text) {
            font-size: 14px;
            font-weight: normal;
            color: #000;
            padding-bottom: 20px;
          }
          @media (max-width: ${theme.breakpoints.mdDown}) {
            .gift-finder :global(.container) {
              padding: 0px;
            }
          }
        `}</style>
      </div>
    </>
  );
};

GiftFinder.layout = HeaderFooterLayout;
GiftFinder.hasColorwash = false;

export const getServerSideProps = wrapper.getServerSideProps(
  async ({ req, store }) => {
    await store.dispatch(getServerSideEssentials(req.url)).catch((error) => {
      console.log(`getServerSideEssentials error: ${error}`);
    });
    store.dispatch(setOnlySSR(false));
  },
);

export default GiftFinder;
